define('app/sdc/alerts/sdc-alerts',[], function () {

});
